<script setup lang="ts">
import { Loader2 } from 'lucide-vue-next'
import { MaybeRef, unref } from 'vue'

defineProps<{
  iconSize?: number
  isLoading?: MaybeRef<boolean>
  hideText?: boolean
}>()
</script>
<template>
  <span class="h-full flex items-center text-sm" v-if="unref(isLoading)">
    <Loader2 :size="iconSize ?? 16" class="animate-spin mr-1" />
    <span v-if="!hideText">Loading...</span>
  </span>
</template>
